(function(){
  const body=document.body;
  document.addEventListener('click',function(e){
    const toggle=e.target.closest('[data-mobile-toggle]');
    if(toggle){
      const open=body.classList.toggle('menu-open');
      toggle.setAttribute('aria-expanded',open?'true':'false');
      return;
    }
    const mobileLink=e.target.closest('.mobile-panel a');
    if(mobileLink) body.classList.remove('menu-open');
  });

  
  function updateCartCount(cart){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent=cart.item_count;
    });
  }

  function formatRandWhole(cents){
    const value=Math.max(0,Math.ceil((Number(cents)||0)/100));
    try{
      return 'R'+new Intl.NumberFormat('en-US',{maximumFractionDigits:0}).format(value);
    }catch(err){
      return 'R'+value;
    }
  }

  function updateFreeShippingProgress(cart){
    const threshold=70000;
    const total=Math.max(0,Number(cart && cart.total_price)||0);
    const remaining=Math.max(0,threshold-total);
    const percent=Math.min(100,(total/threshold)*100);
    document.querySelectorAll('[data-free-shipping-progress]').forEach(function(box){
      const message=box.querySelector('[data-free-shipping-message]');
      const status=box.querySelector('[data-free-shipping-status]');
      const fill=box.querySelector('[data-free-shipping-fill]');
      const track=box.querySelector('.scentify-free-shipping-track');
      if(message){
        message.innerHTML=remaining>0
          ? "You're <strong>"+formatRandWhole(remaining)+"</strong> away from FREE SHIPPING!"
          : "You've unlocked FREE SHIPPING!";
      }
      if(status) status.textContent=remaining>0 ? formatRandWhole(remaining) : 'UNLOCKED';
      if(fill) fill.style.width=percent.toFixed(2)+'%';
      const currentLabel=box.querySelector('[data-free-shipping-current]');
      if(currentLabel) currentLabel.textContent='R'+new Intl.NumberFormat('en-US',{maximumFractionDigits:0}).format(Math.round(total/100));
      if(track){
        track.setAttribute('aria-valuenow',String(Math.min(700,total/100)));
      }
      box.classList.toggle('is-unlocked',remaining===0);
    });
  }

  document.addEventListener('DOMContentLoaded',function(){
    const totalBox=document.querySelector('[data-free-shipping-progress]');
    if(totalBox){
      const current=Number(totalBox.getAttribute('data-current')||0);
      updateFreeShippingProgress({total_price:current});
    }
  });

  // V2.8: Keep collection sidebar category groups open when a filter/sub-link
  // changes the URL and Shopify reloads the collection page.
  document.addEventListener('DOMContentLoaded',function(){
    const sidebar=document.querySelector('.collection-sidebar');
    if(!sidebar) return;

    const storageKey='scentify_collection_sidebar_state';
    try{
      const saved=JSON.parse(sessionStorage.getItem(storageKey)||'{}');
      sidebar.querySelectorAll('details.filter-group').forEach(function(group,index){
        const summary=group.querySelector(':scope > summary');
        const key=(summary ? summary.textContent.trim() : '')+'::'+index;
        if(saved[key]===true) group.open=true;
        else if(saved[key]===false) group.open=false;
      });
    }catch(err){}

    function saveState(){
      const state={};
      sidebar.querySelectorAll('details.filter-group').forEach(function(group,index){
        const summary=group.querySelector(':scope > summary');
        const key=(summary ? summary.textContent.trim() : '')+'::'+index;
        state[key]=group.open;
      });
      try{ sessionStorage.setItem(storageKey,JSON.stringify(state)); }catch(err){}
    }

    sidebar.addEventListener('click',function(e){
      const link=e.target.closest('a');
      if(link && link.href) saveState();
    });

    sidebar.addEventListener('toggle',function(e){
      if(e.target.matches('details.filter-group')) saveState();
    },true);
  });

  async function getCart(){
    const response=await fetch('/cart.js',{headers:{'Accept':'application/json'}});
    if(!response.ok) throw new Error('Cart lookup failed');
    return response.json();
  }

  function inlineMaxStock(form){
    var max=parseInt(form.getAttribute('data-max-stock')||'',10);
    return Number.isFinite(max) && max>=0 ? max : Infinity;
  }

  function updateInlineQtyControls(form, quantity){
    var max=inlineMaxStock(form);
    var plus=form.querySelector('[data-qty-plus]');
    var minus=form.querySelector('[data-qty-minus]');
    if(plus) plus.disabled=(max!==Infinity && quantity>=max);
    if(minus) minus.disabled=false;
  }

  })();


  window.scentifyCollectionQty=function(button,delta){
    var form=button&&button.closest&&button.closest('[data-inline-cart]');
    if(!form)return false;
    var idInput=form.querySelector('input[name="id"]'),variantId=idInput&&idInput.value;
    if(!variantId)return false;
    var display=form.querySelector('[data-qty-value]'),hidden=form.querySelector('input[name="quantity"]');
    var max=parseInt(form.getAttribute('data-max-stock')||'',10);
    if(!Number.isFinite(max)||max<1)max=Infinity;
    var current=Math.max(1,Number(display&&display.textContent)||Number(hidden&&hidden.value)||Number(form.dataset.cartQuantity)||1);
    var target=Math.max(0,Math.min(max,current+(Number(delta)||0)));
    return scentifyQueueCollectionQty(form,variantId,target);
  };

  function scentifyCollectionRenderQty(form,quantity,max){
    var display=form.querySelector('[data-qty-value]');
    var hidden=form.querySelector('input[name="quantity"]');
    var plus=form.querySelector('[data-qty-plus]');
    var minus=form.querySelector('[data-qty-minus]');
    var addButton=form.querySelector('[data-cart-add-trigger]');
    var selector=form.querySelector('[data-inline-qty]');
    var actions=form.closest('.shop-product-actions,.best-seller-actions');
    var viewProduct=actions && actions.querySelector('.shop-view-product,.best-seller-view-product');

    /* V4.3: When collection quantity reaches zero, restore the original
       View Product + cart button state instead of leaving a 0 selector. */
    if(Number(quantity)<=0){
      if(display)display.textContent='1';
      if(hidden)hidden.value='1';
      if(plus)plus.disabled=false;
      if(minus)minus.disabled=false;
      if(selector)selector.hidden=true;
      if(addButton){
        addButton.hidden=false;
        /* V4.4: Keep the button visibly usable after 1 -> 0. The add handler
           itself waits for Shopify to confirm the removal before sending a new
           add, which preserves the race-condition protection without leaving
           the button permanently disabled. */
        addButton.disabled=false;
        addButton.removeAttribute('aria-disabled');
      }
      if(viewProduct)viewProduct.hidden=false;
      form.classList.remove('is-quantity');
      if(actions)actions.classList.remove('has-inline-quantity');
      form.dataset.cartQuantity='0';
      form.dataset.collectionQtyRemoved='1';
      return;
    }

    if(display)display.textContent=String(quantity);
    if(hidden)hidden.value=String(quantity);
    if(plus)plus.disabled=(max!==Infinity&&quantity>=max);
    if(minus)minus.disabled=false;
    if(selector)selector.hidden=false;
    if(addButton)addButton.hidden=true;
    if(viewProduct)viewProduct.hidden=true;
    form.classList.add('is-quantity');
    if(actions)actions.classList.add('has-inline-quantity');
    form.dataset.cartQuantity=String(quantity);
  }

  function scentifyCollectionOptimisticCart(cart,variantId,target){
    if(!cart||!Array.isArray(cart.items))return null;
    var next=JSON.parse(JSON.stringify(cart));
    var index=next.items.findIndex(function(item){return String(item.variant_id)===String(variantId);});
    if(index<0)return null;
    var line=next.items[index];
    var oldQty=Number(line.quantity)||0;
    var oldLineTotal=Number(line.final_line_price||line.line_price||0);
    if(target<=0){
      next.items.splice(index,1);
      next.item_count=Math.max(0,(Number(next.item_count)||0)-oldQty);
      next.total_price=Math.max(0,(Number(next.total_price)||0)-oldLineTotal);
    }else{
      var unitPrice=oldQty>0 ? oldLineTotal/oldQty : Number(line.price)||0;
      var newLineTotal=Math.round(unitPrice*target);
      line.quantity=target;
      if('final_line_price' in line)line.final_line_price=newLineTotal;
      if('line_price' in line)line.line_price=newLineTotal;
      next.item_count=Math.max(0,(Number(next.item_count)||0)-oldQty+target);
      next.total_price=Math.max(0,(Number(next.total_price)||0)-oldLineTotal+newLineTotal);
    }
    return next;
  }

  function scentifyQueueCollectionQty(form,variantId,target){
    if(!form)return false;
    form.dataset.cartQuantity=String(target);
    form.dataset.collectionQtyQueued=String(target);
    var max=parseInt(form.getAttribute('data-max-stock')||'',10);
    if(!Number.isFinite(max)||max<1)max=Infinity;
    scentifyCollectionRenderQty(form,target,max);

    var base=window.__scentifyLatestCart;
    if(base&&Array.isArray(base.items)){
      var optimistic=scentifyCollectionOptimisticCart(base,variantId,target);
      if(optimistic){
        window.__scentifyLatestCart=optimistic;
        if(typeof scentifyPublishCart==='function')scentifyPublishCart(optimistic);
        else document.dispatchEvent(new CustomEvent('scentify:cart-updated',{detail:{cart:optimistic}}));
      }
    }

    if(form.dataset.collectionQtyRequest==='1')return false;
    form.dataset.collectionQtyRequest='1';

    async function send(){
      var desired=Number(form.dataset.collectionQtyQueued);
      var cart=window.__scentifyLatestCart;
      var line=cart&&Array.isArray(cart.items)&&cart.items.find(function(item){return String(item.variant_id)===String(variantId);});
      if(!line){
        cart=await getCart();
        window.__scentifyLatestCart=cart;
        line=Array.isArray(cart.items)&&cart.items.find(function(item){return String(item.variant_id)===String(variantId);});
      }
      if(!line){
        /* Shopify confirms the line is already gone. The Add button can now
           safely accept a fresh quantity-1 add. */
        var removedButton=form.querySelector('[data-cart-add-trigger]');
        if(removedButton){
          removedButton.disabled=false;
          removedButton.removeAttribute('aria-disabled');
        }
        form.dataset.collectionQtyRemoved='0';
        form.dataset.collectionQtyRequest='0';
        return;
      }
      var response=await fetch((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root?window.Shopify.routes.root:'/')+'cart/change.js',{
        method:'POST',credentials:'same-origin',cache:'no-store',
        headers:{Accept:'application/json','Content-Type':'application/json'},
        body:JSON.stringify({id:line.key,quantity:desired})
      });
      if(!response.ok)throw new Error('Cart update failed');
      var serverCart=await response.json();
      window.__scentifyLatestCart=serverCart;
      scentifyPublishCart(serverCart);

      var queued=Number(form.dataset.collectionQtyQueued);
      var serverLine=Array.isArray(serverCart.items)&&serverCart.items.find(function(item){return String(item.variant_id)===String(variantId);});
      var serverQty=serverLine?Number(serverLine.quantity)||0:0;
      if(queued!==serverQty){
        scentifyCollectionRenderQty(form,queued,max);
        await send();
      }else{
        scentifyCollectionRenderQty(form,serverQty,max);
        if(serverQty===0){
          var removedButton=form.querySelector('[data-cart-add-trigger]');
          if(removedButton){
            removedButton.disabled=false;
            removedButton.removeAttribute('aria-disabled');
          }
          form.dataset.collectionQtyRemoved='0';
        }
      }
    }

    send().catch(function(err){
      console.error('[Scentify Collection Quantity]',err);
      getCart().then(function(cart){
        window.__scentifyLatestCart=cart;
        scentifyPublishCart(cart);
        var line=Array.isArray(cart.items)&&cart.items.find(function(item){return String(item.variant_id)===String(variantId);});
        var actual=line?Number(line.quantity)||0:0;
        scentifyCollectionRenderQty(form,actual,max);
        if(actual===0){
          var removedButton=form.querySelector('[data-cart-add-trigger]');
          if(removedButton){
            removedButton.disabled=false;
            removedButton.removeAttribute('aria-disabled');
          }
          form.dataset.collectionQtyRemoved='0';
        }
      }).catch(function(){});
    }).finally(function(){
      form.dataset.collectionQtyRequest='0';
      var queued=Number(form.dataset.collectionQtyQueued);
      var current=Number(form.dataset.cartQuantity);
      if(queued!==current){scentifyQueueCollectionQty(form,variantId,queued);}
    });
    return false;
  }

  window.scentifyCollectionSetQty=function(form,requested){
    if(!form)return false;
    var idInput=form.querySelector('input[name="id"]'),variantId=idInput&&idInput.value;
    if(!variantId)return false;
    var max=parseInt(form.getAttribute('data-max-stock')||'',10);
    if(!Number.isFinite(max)||max<1)max=Infinity;
    var target=parseInt(requested,10);
    if(!Number.isFinite(target))target=1;
    target=Math.max(1,Math.min(max,target));
    return scentifyQueueCollectionQty(form,variantId,target);
  };

  document.addEventListener('click',function(e){
    var button=e.target.closest&&e.target.closest('[data-inline-qty] [data-qty-minus],[data-inline-qty] [data-qty-plus]');
    if(!button)return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var delta=button.matches('[data-qty-plus]')?1:-1;
    window.scentifyCollectionQty(button,delta);
  },true);

/* V4.2: Submit the newsletter form without a full-page reload/hash jump. */
(function(){
  function initNewsletterForms(){
    document.querySelectorAll('.newsletter-customer-form').forEach(function(form){
      if(form.dataset.newsletterAjaxReady === 'true') return;
      form.dataset.newsletterAjaxReady = 'true';
      form.addEventListener('submit', function(event){
        if(form.dataset.newsletterSubmitting === 'true') return;
        var email = form.querySelector('input[type="email"]');
        var button = form.querySelector('button[type="submit"]');
        if(!email || !button) return;
        if(!email.checkValidity()){
          email.reportValidity();
          return;
        }
        event.preventDefault();
        form.dataset.newsletterSubmitting = 'true';
        form.classList.add('is-submitting');
        button.disabled = true;
        var originalLabel = button.textContent;
        button.textContent = 'SUBSCRIBING…';
        var body = new FormData(form);
        fetch(form.action, {
          method: 'POST',
          body: body,
          credentials: 'same-origin',
          redirect: 'follow',
          headers: { 'Accept': 'text/html' }
        }).then(function(response){
          if(!response.ok) throw new Error('Newsletter submission failed');
          return response.text();
        }).then(function(){
          var existing = form.querySelector('.newsletter-message');
          if(existing) existing.remove();
          var message = document.createElement('div');
          message.className = 'newsletter-message newsletter-success';
          message.setAttribute('role','status');
          message.setAttribute('aria-live','polite');
          message.textContent = "✓ You're subscribed! Thanks for joining Scentify Fragrances.";
          form.insertBefore(message, form.querySelector('.newsletter-form'));
          form.classList.remove('is-submitting');
          form.classList.add('is-complete');
          button.disabled = false;
          button.textContent = originalLabel;
          form.dataset.newsletterSubmitting = 'false';
        }).catch(function(){
          form.classList.remove('is-submitting');
          button.disabled = false;
          button.textContent = originalLabel;
          form.dataset.newsletterSubmitting = 'false';
          var existing = form.querySelector('.newsletter-message');
          if(existing) existing.remove();
          var message = document.createElement('div');
          message.className = 'newsletter-message newsletter-error';
          message.setAttribute('role','alert');
          message.setAttribute('aria-live','assertive');
          message.textContent = "We couldn't complete your subscription. Please try again.";
          form.insertBefore(message, form.querySelector('.newsletter-form'));
        });
      });
    });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initNewsletterForms, {once:true});
  } else {
    initNewsletterForms();
  }
})();


/* Scentify DRAWER CART ENGINE - legacy drawer only
   No floating/minimized cart UI. Add-to-cart updates the existing drawer
   contents but leaves the drawer closed; the header cart opens the drawer. */
(function(){
  'use strict';

  async function scentifyLegacyCart(){
    var response=await fetch('/cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
    if(!response.ok) throw new Error('Cart lookup failed');
    return response.json();
  }

  function scentifyLegacyCount(cart){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent=cart.item_count;
    });
  }

  function scentifyLegacyShipping(cart){
    var threshold=70000;
    var total=Math.max(0,Number(cart && cart.total_price)||0);
    var remaining=Math.max(0,threshold-total);
    var percent=Math.min(100,total/threshold*100);
    document.querySelectorAll('[data-free-shipping-progress]').forEach(function(box){
      var message=box.querySelector('[data-free-shipping-message]');
      var fill=box.querySelector('[data-free-shipping-fill]');
      var track=box.querySelector('.scentify-free-shipping-track');
      if(message){
        message.innerHTML=remaining
          ? "You're <strong>R"+new Intl.NumberFormat('en-US',{maximumFractionDigits:0}).format(Math.ceil(remaining/100))+"</strong> away from FREE SHIPPING!"
          : "You've unlocked FREE SHIPPING!";
      }
      if(fill) fill.style.width=percent.toFixed(2)+'%';
      var currentLabel=box.querySelector('[data-free-shipping-current]');
      if(currentLabel) currentLabel.textContent='R'+new Intl.NumberFormat('en-US',{maximumFractionDigits:0}).format(Math.round(total/100));
      if(track) track.setAttribute('aria-valuenow',String(Math.min(700,total/100)));
      box.classList.toggle('is-unlocked',remaining===0);
    });
  }

  function scentifyLegacyInline(form,quantity){
    var add=form.querySelector('[data-cart-add-trigger],.scentify-add-button');
    var box=form.querySelector('[data-inline-qty]');
    var value=form.querySelector('[data-qty-value]');
    var input=form.querySelector('input[name="quantity"]');
    var actions=form.closest('.shop-product-actions,.best-seller-actions');
    var view=actions && actions.querySelector('.shop-view-product,.best-seller-view-product');
    if(box) box.hidden=false;
    if(add) add.hidden=true;
    if(value) value.textContent=quantity;
    if(input) input.value=quantity;
    form.classList.add('is-quantity');
    if(actions) actions.classList.add('has-inline-quantity');
    if(view) view.hidden=true;
    form.dataset.cartQuantity=String(quantity);
  }

  function scentifyReplaceDrawerHtml(html,keepOpen){
    if(!html)return false;
    var current=document.querySelector('[data-cart-drawer]');
    if(!current)return false;
    var doc=new DOMParser().parseFromString(html,'text/html');
    var fresh=doc.querySelector('[data-cart-drawer]');
    if(!fresh)return false;
    if(keepOpen){
      fresh.classList.add('is-open');
      fresh.setAttribute('aria-hidden','false');
      document.body.classList.add('cart-drawer-open');
    }else{
      fresh.classList.remove('is-open');
      fresh.setAttribute('aria-hidden','true');
      document.body.classList.remove('cart-drawer-open');
    }
    current.replaceWith(fresh);
    return true;
  }

  async function scentifyLegacyRefreshDrawerClosed(cart){
    var response=await fetch('/cart?section_id=cart-drawer&_scentify_drawer='+Date.now(),{
      credentials:'same-origin',cache:'no-store',headers:{Accept:'text/html'}
    });
    if(!response.ok)throw new Error('Drawer refresh failed');
    var html=await response.text();
    if(!scentifyReplaceDrawerHtml(html,false))throw new Error('Fresh cart drawer not found');
    if(cart)scentifyLegacyShipping(cart);
  }


  async function scentifyFreshCartForVariant(variantId,minimumQuantity){
    var delays=[0,60,140,260],last=null;
    for(var i=0;i<delays.length;i++){
      if(delays[i])await new Promise(function(resolve){setTimeout(resolve,delays[i]);});
      try{
        var cart=await scentifyLegacyCart();last=cart;
        var line=(cart.items||[]).find(function(item){return String(item.variant_id)===String(variantId);});
        if(line&&Number(line.quantity)>=Number(minimumQuantity||1))return cart;
      }catch(err){}
    }
    return last;
  }

  function scentifyApplyBundledDrawer(html,keepOpen){
    if(!html)return false;
    var current=document.querySelector('[data-cart-drawer]');
    if(!current)return false;
    var doc=new DOMParser().parseFromString(html,'text/html');
    var fresh=doc.querySelector('[data-cart-drawer]');
    if(!fresh)return false;
    var wasOpen=keepOpen===true || current.classList.contains('is-open');
    if(wasOpen){
      fresh.classList.add('is-open');
      fresh.setAttribute('aria-hidden','false');
      document.body.classList.add('cart-drawer-open');
    }else{
      fresh.classList.remove('is-open');
      fresh.setAttribute('aria-hidden','true');
    }
    current.replaceWith(fresh);

    /* V5.0: The bundled Shopify section replaces the entire drawer DOM,
       including the server-rendered free-shipping bar. Re-apply the
       authoritative cart immediately after that replacement so the bar
       cannot fall back to the stale data-current value from the section HTML. */
    var latestCart=window.__scentifyLatestCart;
    if(latestCart && typeof scentifyLegacyShipping==='function'){
      scentifyLegacyShipping(latestCart);
    }

    return true;
  }

  async function scentifyConfirmCollectionRemoval(form,variantId){
    if(!form || form.dataset.collectionQtyRemoved!=='1') return true;

    var delays=[0,80,160,240,360,520,760,1000];
    for(var i=0;i<delays.length;i++){
      if(delays[i]) await new Promise(function(resolve){setTimeout(resolve,delays[i]);});
      try{
        var cart=await scentifyLegacyCart();
        window.__scentifyLatestCart=cart;
        var line=(cart.items||[]).find(function(item){
          return String(item.variant_id)===String(variantId);
        });
        if(!line){
          form.dataset.collectionQtyRemoved='0';
          return true;
        }
      }catch(err){}
    }

    try{
      var cart=await scentifyLegacyCart();
      var line=(cart.items||[]).find(function(item){
        return String(item.variant_id)===String(variantId);
      });
      if(line){
        var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
        var response=await fetch(root+'cart/change.js',{
          method:'POST',
          credentials:'same-origin',
          cache:'no-store',
          headers:{Accept:'application/json','Content-Type':'application/json'},
          body:JSON.stringify({id:line.key,quantity:0})
        });
        if(response.ok){
          var cleared=await response.json();
          window.__scentifyLatestCart=cleared;
          if(window.scentifyPublishCart) window.scentifyPublishCart(cleared);
        }
      }
      for(var j=0;j<6;j++){
        if(j) await new Promise(function(resolve){setTimeout(resolve,100+j*100);});
        var latest=await scentifyLegacyCart();
        window.__scentifyLatestCart=latest;
        var remaining=(latest.items||[]).find(function(item){
          return String(item.variant_id)===String(variantId);
        });
        if(!remaining){
          form.dataset.collectionQtyRemoved='0';
          return true;
        }
      }
    }catch(err){}

    return false;
  }

  async function scentifyLegacyAdd(form,button){
    if(!form || !button || form.dataset.legacyCartBusy==='1') return;
    var idInput=form.querySelector('input[name="id"]'), id=idInput&&idInput.value;
    if(!id) return;

    form.dataset.legacyCartBusy='1';
    var original=button.innerHTML;
    button.disabled=true;

    if(form.dataset.collectionQtyRemoved==='1'){
      var removalConfirmed=await scentifyConfirmCollectionRemoval(form,id);
      if(!removalConfirmed){
        button.disabled=false;
        form.dataset.legacyCartBusy='0';
        return;
      }
    }
    try{
      var quantityInput=form.querySelector('input[name="quantity"]');
      var requested=Math.max(1,parseInt(quantityInput&&quantityInput.value,10)||1);
      var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      var response=await fetch(root+'cart/add.js',{
        method:'POST',credentials:'same-origin',cache:'no-store',
        headers:{Accept:'application/json','Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:Number(id),quantity:requested}],sections:'cart-drawer',sections_url:window.location.pathname})
      });
      var data=await response.json().catch(function(){return null;});
      if(!response.ok){console.error('[Scentify Cart] Add failed',data);return;}
      /* Shopify renders the requested cart-drawer section after the add has
         completed. Apply that confirmed HTML immediately so the first item
         exists in the drawer before the floating-cart button is clicked. */
      var bundledDrawer=data&&data.sections&&data.sections['cart-drawer'];
      if(bundledDrawer)scentifyApplyBundledDrawer(bundledDrawer,false);
      var addedLine=data&&data.items&&data.items[0], addedQuantity=addedLine?Number(addedLine.quantity)||requested:requested;
      scentifyLegacyInline(form,addedQuantity);
      button.innerHTML='ADDED ✓'; setTimeout(function(){button.innerHTML=original;},900);

      /* Use Shopify's authoritative cart JSON after every add.
         The /cart/add.js response includes the updated line quantity, but our
         drawer must stay synchronized with the complete cart (totals, other
         lines, discounts, etc.). The bundled section is then applied last so
         the drawer DOM exactly matches Shopify's confirmed result. */
      /* V4.9: After /cart/add.js, Shopify's /cart.js can briefly return
         the pre-add cart while the write propagates. That was why the first
         product sometimes left the free-shipping bar unchanged until a later
         product was added. Wait for the added variant to be visible in the
         authoritative cart before publishing totals to the drawer/progress UI. */
      var cart=await scentifyFreshCartForVariant(id,addedQuantity);
      if(!cart || !Array.isArray(cart.items) || !cart.items.some(function(item){
        return String(item.variant_id)===String(id) && Number(item.quantity)>=Number(addedQuantity||1);
      })){
        cart=await scentifyLegacyCart();
      }
      window.__scentifyLatestCart=cart;
      window.__scentifyCartWriteAt=Date.now();
      if(window.scentifyPublishCart){
        window.scentifyPublishCart(cart);
      }else{
        window.__scentifyLatestCart=cart;
        if(window.scentifySetFloaterCart)window.scentifySetFloaterCart(cart,true);
        if(window.scentifyRenderCartDrawer)window.scentifyRenderCartDrawer(cart);
        document.dispatchEvent(new CustomEvent('scentify:cart-updated',{detail:{cart:cart}}));
      }

      /* The bundled drawer section is rendered by Shopify after the add has
         completed, so use it as the final drawer DOM after the cart JSON sync. */
      if(bundledDrawer){
        scentifyApplyBundledDrawer(bundledDrawer,false);
      }else if(window.scentifyRenderCartDrawer){
        window.scentifyRenderCartDrawer(cart);
      }
      scentifyShipping(cart);
    }catch(error){console.error('[Scentify Cart] Add request failed',error);}
    finally{form.dataset.legacyCartBusy='0';button.disabled=false;}
  }
  /* V4.8: expose the legacy add routine to the /shop reliability bridge. */
  window.scentifyLegacyAdd=scentifyLegacyAdd;
  /* Collection quick-add buttons. */
  document.addEventListener('click',function(event){
    var button=event.target.closest && event.target.closest(
      '[data-inline-cart] [data-cart-add-trigger],.scentify-product-form .scentify-add-button'
    );
    if(!button || button.disabled) return;
    var form=button.closest('[data-inline-cart],.scentify-product-form');
    if(!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    scentifyLegacyAdd(form,button);
  },true);

  /* Product-page submit buttons. */
  document.addEventListener('submit',function(event){
    var form=event.target && event.target.closest &&
      event.target.closest('.scentify-product-form,[data-inline-cart]');
    if(!form) return;
    var button=form.querySelector('.scentify-add-button,[data-cart-add-trigger]');
    if(!button || button.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    scentifyLegacyAdd(form,button);
  },true);
})();

/* Scentify CART/PDP FIX PACK - draft
   Keeps the existing drawer design and restores delegated cart controls. */
(function(){
  'use strict';

  function scentifyDrawer(){
    return document.querySelector('[data-cart-drawer]');
  }

  function scentifyOpenDrawer(){
    var d=scentifyDrawer();
    if(!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden','false');
    document.body.classList.add('cart-drawer-open');
  }

  function scentifyCloseDrawer(){
    var d=scentifyDrawer();
    if(!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden','true');
    document.body.classList.remove('cart-drawer-open');
  }

  async function scentifyGetCart(){
    var r=await fetch('/cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
    if(!r.ok) throw new Error('Cart request failed');
    return r.json();
  }

  function scentifyCount(cart){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent=cart.item_count;
    });
  }

  function scentifyShipping(cart){
    var threshold=70000;
    var total=Math.max(0,Number(cart.total_price)||0);
    var remaining=Math.max(0,threshold-total);
    var percent=Math.min(100,total/threshold*100);
    document.querySelectorAll('[data-free-shipping-progress]').forEach(function(box){
      var msg=box.querySelector('[data-free-shipping-message]');
      var fill=box.querySelector('[data-free-shipping-fill]');
      var track=box.querySelector('.scentify-free-shipping-track');
      if(msg) msg.innerHTML=remaining
        ? "You're <strong>R"+new Intl.NumberFormat('en-US',{maximumFractionDigits:0}).format(Math.ceil(remaining/100))+"</strong> away from FREE SHIPPING!"
        : "You've unlocked FREE SHIPPING!";
      if(fill) fill.style.width=percent.toFixed(2)+'%';
      var currentLabel=box.querySelector('[data-free-shipping-current]');
      if(currentLabel) currentLabel.textContent='R'+new Intl.NumberFormat('en-US',{maximumFractionDigits:0}).format(Math.round(total/100));
      if(track) track.setAttribute('aria-valuenow',String(Math.min(700,total/100)));
      box.classList.toggle('is-unlocked',remaining===0);
    });
  }

  function scentifyAgent(cart){
    document.querySelectorAll('[data-agent-minimum-notice]').forEach(function(box){
      var min=Number(box.getAttribute('data-minimum')||14);
      var count=Math.max(0,Number(cart.item_count)||0);
      var capped=Math.min(min,count);
      var remaining=Math.max(0,min-count);
      var msg=box.querySelector('[data-agent-minimum-message]');
      var countLabel=box.querySelector('[data-agent-minimum-count]');
      var fill=box.querySelector('[data-agent-minimum-fill]');
      if(countLabel) countLabel.textContent=capped+' / '+min;
      if(fill) fill.style.width=((capped/min)*100).toFixed(2)+'%';
      if(msg) msg.textContent=count>=min ? '✓ Minimum reached' : remaining+' more needed';
      box.setAttribute('data-current',String(count));
      box.classList.toggle('is-reached',count>=min);
    });
  }
  window.scentifySyncCartIndicators=function(cart){
    if(!cart) return;
    scentifyCount(cart);
    scentifyShipping(cart);
    scentifyAgent(cart);
  };

  document.addEventListener('scentify:cart-updated',function(e){
    var cart=e && e.detail && e.detail.cart;
    if(cart) window.scentifySyncCartIndicators(cart);
  });

  function scentifyPublishCart(cart){
    if(!cart) return;
    /* Push the confirmed cart into the floater synchronously. If the floater
       script has not built its DOM yet, keep the cart pending and replay it
       as soon as the floater initializes. */
    window.__scentifyLatestCart=cart;
    window.__scentifyCartWriteAt=Date.now();
    if(window.scentifySetFloaterCart) window.scentifySetFloaterCart(cart,true);
    scentifyCount(cart); scentifyShipping(cart); scentifyAgent(cart);
    /* Keep the already-open drawer DOM synchronized with the confirmed cart.
       This avoids waiting for a full section replacement when an existing line
       item is added again (1 -> 2 -> 3 -> 4 -> 5). */
    var drawerSynced=scentifySyncDrawerFromCart(cart);
    if(!drawerSynced && window.scentifyRenderCartDrawer) window.scentifyRenderCartDrawer(cart);
    document.dispatchEvent(new CustomEvent('scentify:cart-updated',{detail:{cart:cart}}));
  }

  /* Expose the single cart publisher to the legacy add handler above so the
     first confirmed add always renders the drawer immediately. */
  window.scentifyPublishCart=scentifyPublishCart;

  function scentifySyncDrawerFromCart(cart){
    if(!cart)return false;
    var drawers=document.querySelectorAll('[data-cart-drawer]');
    if(!drawers.length)return false;
    var needsRefresh=false;
    var seen={};

    (cart.items||[]).forEach(function(item){
      seen[item.key]=true;
      drawers.forEach(function(drawer){
        var rows=drawer.querySelectorAll('[data-line-key="'+CSS.escape(item.key)+'"]');
        if(!rows.length){
          needsRefresh=true;
          return;
        }
        rows.forEach(function(row){
          var qty=row.querySelector('[data-line-quantity]');
          if(qty)qty.textContent=String(item.quantity);
          var price=row.querySelector('[data-line-total],[data-line-price]');
          if(price)price.textContent='R '+(Number(item.final_line_price||0)/100).toFixed(2);
          row.setAttribute('data-line-quantity',String(item.quantity));
        });
      });
    });

    drawers.forEach(function(drawer){
      drawer.querySelectorAll('[data-line-key]').forEach(function(row){
        if(!seen[row.getAttribute('data-line-key')])needsRefresh=true;
      });
      var total=drawer.querySelector('[data-cart-drawer-total]');
      if(total)total.textContent='R '+(Number(cart.total_price||0)/100).toFixed(2);
      var productCount=drawer.querySelector('[data-cart-products-count] strong');
      if(productCount)productCount.textContent=String(Number(cart.item_count)||0);
    });

    scentifyShipping(cart);
    scentifyAgent(cart);
    return !needsRefresh;
  }

  async function scentifyRefreshDrawer(keepOpen,cart){
    var current=scentifyDrawer();
    if(!current) return;
    var response=await fetch('/cart?section_id=cart-drawer',{credentials:'same-origin',cache:'no-store'});
    if(!response.ok) throw new Error('Drawer refresh failed');
    var html=await response.text();
    var doc=new DOMParser().parseFromString(html,'text/html');
    var fresh=doc.querySelector('[data-cart-drawer]');
    if(!fresh) throw new Error('Fresh cart drawer not found');
    if(keepOpen){
      fresh.classList.add('is-open');
      fresh.setAttribute('aria-hidden','false');
      document.body.classList.add('cart-drawer-open');
    }
    current.replaceWith(fresh);
    if(cart){ scentifyShipping(cart); scentifyAgent(cart); }
  }

  async function scentifyChangeLine(key,quantity){
    try{
      var r=await fetch('/cart/change.js',{
        method:'POST',
        credentials:'same-origin',
        cache:'no-store',
        headers:{Accept:'application/json','Content-Type':'application/json'},
        body:JSON.stringify({id:key,quantity:Math.max(0,quantity)})
      });
      if(!r.ok) throw new Error('Cart change failed');
      var cart=await r.json();
      scentifyPublishCart(cart);
      await scentifyRefreshDrawer(true,cart);
    }catch(err){
      console.error('[Scentify Cart Fix]',err);
    }
  }

  async function scentifyHeaderCart(){
    try{
      var cart=await scentifyGetCart();
      scentifyCount(cart);
      scentifyShipping(cart);
      scentifyAgent(cart);
      await scentifyRefreshDrawer(true);
    }catch(err){
      console.error('[Scentify Cart Fix]',err);
      scentifyOpenDrawer();
    }
  }

  /* Drawer close. */
  document.addEventListener('click',function(e){
    var close=e.target.closest && e.target.closest('[data-cart-drawer-close]');
    if(close){
      e.preventDefault();
      e.stopImmediatePropagation();
      scentifyCloseDrawer();
    }
  },true);

  /* Drawer + / - / delete. Delegation survives every drawer re-render. */
  document.addEventListener('click',function(e){
    var button=e.target.closest && e.target.closest('[data-cart-minus],[data-cart-plus],[data-cart-remove]');
    if(!button) return;
    var item=button.closest('[data-cart-item]');
    if(!item) return;
    var key=item.getAttribute('data-line-key');
    if(!key) return;
    var quantity=Number((item.querySelector('[data-line-quantity]')||{}).textContent)||0;
    if(button.matches('[data-cart-minus]')) quantity=Math.max(0,quantity-1);
    else if(button.matches('[data-cart-plus]')) quantity=quantity+1;
    else quantity=0;
    e.preventDefault();
    e.stopImmediatePropagation();
    scentifyChangeLine(key,quantity);
  },true);

  /* Product-page quantity selector: restore +/- behavior. */
  document.addEventListener('click',function(e){
    var button=e.target.closest && e.target.closest('.scentify-quantity-control [data-qty-minus],.scentify-quantity-control [data-qty-plus]');
    if(!button) return;
    var form=button.closest('.scentify-product-form');
    var input=form && form.querySelector('input[name="quantity"]');
    if(!input) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var current=Math.max(1,Number(input.value)||1);
    var maxAttr=form.getAttribute('data-max-stock');
    var max=Number.isFinite(Number(maxAttr)) && Number(maxAttr)>=0 ? Number(maxAttr) : Infinity;
    var next=button.hasAttribute('data-qty-plus') ? current+1 : current-1;
    next=Math.max(1,next);
    if(max!==Infinity) next=Math.min(max,next);
    input.value=String(next);
    input.dispatchEvent(new Event('change',{bubbles:true}));
  },true);

  /* Also make manual PDP quantity edits stay within min/max. */
  document.addEventListener('change',function(e){
    var input=e.target;
    if(!input.matches || !input.matches('.scentify-product-form input[name="quantity"]')) return;
    var min=Math.max(1,Number(input.getAttribute('min'))||1);
    var form=input.closest('.scentify-product-form');
    var maxAttr=form && form.getAttribute('data-max-stock');
    var max=Number.isFinite(Number(maxAttr)) && Number(maxAttr)>=0 ? Math.max(min,Number(maxAttr)) : Infinity;
    var value=Math.max(min,Number(input.value)||min);
    if(max!==Infinity) value=Math.min(max,value);
    input.value=String(value);
  },true);


  /* Full /cart page controls: update the real Shopify cart, then re-render the page section. */
  async function scentifyRefreshMainCart(){
    var current=document.querySelector('.scentify-main-cart');
    if(!current) return;
    var response=await fetch('/cart?section_id=main-cart',{credentials:'same-origin',cache:'no-store'});
    if(!response.ok) throw new Error('Main cart refresh failed');
    var html=await response.text();
    var doc=new DOMParser().parseFromString(html,'text/html');
    var fresh=doc.querySelector('.scentify-main-cart');
    if(!fresh) throw new Error('Fresh main cart not found');
    current.replaceWith(fresh);
    var cart=await scentifyGetCart();
    scentifyCount(cart);
    scentifyShipping(cart);
    scentifyAgent(cart);
  }

  async function scentifyChangeMainCartLine(key,quantity){
    try{
      var response=await fetch('/cart/change.js',{
        method:'POST',
        credentials:'same-origin',
        cache:'no-store',
        headers:{Accept:'application/json','Content-Type':'application/json'},
        body:JSON.stringify({id:key,quantity:Math.max(0,quantity)})
      });
      if(!response.ok) throw new Error('Main cart change failed');
      var cart=await response.json();
      scentifyPublishCart(cart);
      await scentifyRefreshMainCart();
    }catch(err){
      console.error('[Scentify Main Cart]',err);
    }
  }

  document.addEventListener('click',function(e){
    var button=e.target.closest && e.target.closest('[data-main-cart-minus],[data-main-cart-plus],[data-main-cart-remove]');
    if(!button) return;
    var item=button.closest('[data-main-cart-item]');
    if(!item) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var quantityNode=item.querySelector('[data-main-line-quantity]');
    var current=Math.max(1,Number(quantityNode && quantityNode.textContent)||1);
    var quantity=button.hasAttribute('data-main-cart-remove') ? 0 :
      (button.hasAttribute('data-main-cart-plus') ? current+1 : Math.max(0,current-1));
    scentifyChangeMainCartLine(item.getAttribute('data-line-key'),quantity);
  },true);

  /* Initialize progress/count from the real cart on every page. */
  function init(){
    scentifyGetCart().then(function(cart){
      scentifyCount(cart);
      scentifyShipping(cart);
      scentifyAgent(cart);
    }).catch(function(){});
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();

  window.scentifyCartFix={
    open:scentifyHeaderCart,
    refresh:function(){return scentifyGetCart().then(function(c){scentifyCount(c);scentifyShipping(c);scentifyAgent(c);return scentifyRefreshDrawer(true,c);})}
  };
})();


/* Scentify V4.7 - /shop quick-add reliability patch */
(function(){
  'use strict';
  if(window.__scentifyShopQuickAddCaptureV47) return;
  window.__scentifyShopQuickAddCaptureV47=true;
  window.addEventListener('click',function(event){
    if(event.defaultPrevented) return;
    if(event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var button=event.target && event.target.closest ? event.target.closest('.shop-product-actions .shop-quick-add-form [data-cart-add-trigger]') : null;
    if(!button || button.disabled) return;
    var form=button.closest('.shop-quick-add-form');
    if(!form || !form.hasAttribute('data-inline-cart')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if(typeof scentifyLegacyAdd==='function') scentifyLegacyAdd(form,button);
  },true);
})();
